
import { BookingCategory, BookingPayloadBase, BookingClientType, BookingPayloadDocumentReview, BookingPayloadLegalAdvice, BookingDetailsFields } from 'common/types/MemberBooking'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import moment from 'moment/moment'

export function buildBasePayload(
  profile: MemberProfileExtendedType,
  bookingDetails: BookingDetailsFields,
  bookingCategory: BookingCategory
): BookingPayloadBase {
  return {
    lawyer: profile.metadata.id,
    first_name: bookingDetails.firstName,
    last_name: bookingDetails.lastName,
    email: bookingDetails.emailAddress,
    phone_number: bookingDetails.phoneNumber,
    appointment_type: bookingCategory,
    client_type: BookingClientType[bookingDetails.bookingClientType],
    occupation: bookingDetails.occupation,
    is_video: bookingDetails.contactMethod === 'Video',
    notes: bookingDetails.userNotes,
  }
}

export function buildDocumentReviewPayload(
  payloadBase: BookingPayloadBase,
  bookingDateTime: Date | null,
  bookingDetails: BookingDetailsFields,
  selectedFile?: File | null
): BookingPayloadDocumentReview {
  const docReviewPayload: BookingPayloadDocumentReview = selectedFile
    ? {
        ...payloadBase,
        deadline: moment(bookingDateTime).toISOString(),
        document_to_review: selectedFile,
      }
    : {
        ...payloadBase,
        deadline: moment(bookingDateTime).toISOString(),
        document_to_review_url: bookingDetails.fileUrl,
      }
  return docReviewPayload
}

export function buildLegalAdvicePayload(
  payloadBase: BookingPayloadBase,
  bookingDateTime: Date | null,
  bookingDetails: BookingDetailsFields
): BookingPayloadLegalAdvice {
  return {
    ...payloadBase,
    accessibility_requirements: bookingDetails.accessibilityRequirements,
    start: moment(bookingDateTime).toISOString(),
    end: moment(bookingDateTime).add(30, 'minutes').toISOString(),
  }
}
